module.exports = {"id":"192985","name":"Kevin De Bruyne","rating":"91","photo":"./data/images/photos/1/192985.png","club":{"name":"Manchester City","logo":"./data/images/clubs/ManchesterCity.png"},"positions":["MOC","MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KevinDeBruyne0.json
// module id = 2339
// module chunks = 0